import React, { Component } from 'react';

class Hiring extends Component {
  render () {
    return (
      <main className='main'>
        <div className='l-container'>
          <h1 className='u-text-center'>We're hiring!</h1>
          <div className='l-container l-container--x-narrow'>
            <p>
              We are looking for an experienced and qualified BSL Teacher to join our team on a freelance basis.
            </p>
            <p>
              Due to a high volume of Level 1 enrolments, you would initially be tutoring Level 1 students in view of taking on Level 2 students after training.
            </p>
            <p>
              All training is free and any external training, such as IBSL’s Teacher Training, would count towards your CPD. Experience of Level 1 teaching and time-management are essential. You must also have a natural encouraging and friendly vibe in your teaching methods.
            </p>
            <p>
              Please email us your CV to <a href='mailto:info@bslcourses.co.uk'>info@bslcourses.co.uk</a> and include a couple of dates and times when would be suitable to meet via Skype (webcam) for an informal interview.
            </p>
          </div>
        </div>
      </main>
    );
  }
}

export default Hiring;



// WEBPACK FOOTER //
// ./src/views/Main/Hiring/index.js